var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.84 68.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zas\xF3b 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "34.42 68.84 28.71 63.11 21.25 66.22 18.17 58.74 10.08 58.76 10.1 50.67 2.62 47.59 4.89 42.11 6.43 43.64 5.24 46.51 12.1 49.34 12.09 56.75 19.5 56.74 22.33 63.6 29.18 60.75 34.42 66 39.66 60.75 46.51 63.6 49.34 56.74 56.75 56.75 56.74 49.34 63.6 46.51 60.75 39.66 66 34.42 60.75 29.18 63.6 22.33 56.74 19.5 56.75 12.09 49.34 12.1 46.51 5.24 39.66 8.09 34.42 2.84 29.18 8.09 22.33 5.24 19.5 12.1 12.09 12.09 12.1 19.5 5.24 22.33 8.09 29.18 2.84 34.42 8.08 39.65 7.25 41.66 0 34.42 5.73 28.71 2.62 21.25 10.1 18.17 10.08 10.08 18.17 10.1 21.25 2.62 28.71 5.73 34.42 0 40.13 5.73 47.59 2.62 50.67 10.1 58.76 10.08 58.74 18.17 66.22 21.25 63.11 28.71 68.84 34.42 63.11 40.13 66.22 47.59 58.74 50.67 58.76 58.76 50.67 58.74 47.59 66.22 40.13 63.11 34.42 68.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.42,58.42a24,24,0,1,1,24-24A24,24,0,0,1,34.42,58.42Zm0-46a22,22,0,1,0,22,22A22,22,0,0,0,34.42,12.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.82,46.88a1,1,0,0,1-.71-.29L19.92,37.4a1,1,0,0,1-.29-.71,1,1,0,0,1,.29-.71l3.54-3.54a1,1,0,0,1,1.41,0l4.95,5L44,23.25a1,1,0,0,1,1.41,0l4.24,4.24L48.2,28.9l-3.54-3.54L30.53,39.52a1,1,0,0,1-1.41,0l-4.95-5-2.12,2.12,7.78,7.78L45.4,28.9l1.41,1.41L30.53,46.59A1,1,0,0,1,29.82,46.88Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIco);
export default __webpack_public_path__ + "static/media/order-ico.3987bd81eb8a935fc41c75080e7e2198.svg";
export { ForwardRef as ReactComponent };